import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../../config/theme';
import Winner from '../../components/Winner';
import Typography from '@material-ui/core/Typography';
import InfoMessage from '../../components/InfoMessage';

const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: 400
  },
  mainHeader: {
    textAlign: 'left'
  },
  lightningIcon: {
    top: '7px',
    position: 'relative',
    filter: 'brightness(0) saturate(100%) invert(18%) sepia(91%) saturate(2367%) hue-rotate(219deg) brightness(92%) contrast(102%)',
  },
  title: {
    fontWeight: 700,
    color: '#1A1A1A',
    '& small': {
      fontWeight: 400,
      color: '#666666',
      fontSize: '70%',
      marginLeft: '10px'
    }
  }
}));

export default function Winners({ winners, loadingWinners, currentUser, influencer }) {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.main}>
        <div className={classes.mainHeader}>
          <Typography variant="h5" className={classes.title}>
            <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/trophy.svg" className={classes.lightningIcon} />&nbsp;
            Ganhadores
            <small>
              Sortudos
            </small>
          </Typography>
          <br />
        </div>
        {loadingWinners && (
          <div>Carregando...</div>
        )}
        <div className={classes.campaigns}>
          {!loadingWinners && winners.length != 0 && (
            winners.map((winner, index) => (
              <Winner winner={winner} influencer={influencer} currentUser={currentUser} key={index} />
            )
          ))}
        </div>
        {!loadingWinners && winners.length == 0 && (
          <InfoMessage>Nenhuma ganhador encontrado</InfoMessage>
        )}
      </div>
    </ThemeProvider>
  )
}
